import React from 'react';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import slotimg from "../../images/free.png";
import './adminSupplierMaster.css';
import Pagination from 'react-js-pagination';


const AdminSupplierMaster = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);

  const [ isCreate,setCreate ] = useState(false);
  const [ refundpopup,setrefundpopup ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
  const ItemCodeOptions = [

    { value: 'Chef', label: 'Chef' },
    { value: 'Captain', label: 'Captain' },
    { value: 'Waiter', label: 'Waiter' },
    // Add more options as needed
  ];
  
  const [DeleteId, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    shop_id: "", 
    supplier_name: null, 
    supplier_code: null,
    address: null,
    mobile_no: "",
    gst_no: null,
  
});
const [remarks, setRemarks] = useState('');
const [updateformData, setUpdateFormData] = useState({
  id:null,
  shop_id: "", 
  supplier_name: null, 
  supplier_code: null,
  address: null,
  mobile_no: "",
  gst_no: null,
});

console.log(formData)
const [currentPage, setCurrentPage] = useState(1);
 const [itemsPerPage] = useState(10); // Number of items per page
 const [searchTerm, setSearchTerm] = useState('');
 
 // Filtering tables based on search term
 const filteredTables = tables.filter((item) => {
   return (
     item.supplier_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
     item.supplier_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
     item.address.toLowerCase().includes(searchTerm.toLowerCase()) ||
     item.mobile_no.toLowerCase().includes(searchTerm.toLowerCase()) ||
     item.gst_no.toLowerCase().includes(searchTerm.toLowerCase()) 

   );
 });
 
 // Pagination logic
 const indexOfLastItem = currentPage * itemsPerPage;
 const indexOfFirstItem = indexOfLastItem - itemsPerPage;
 const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
 const totalItems = filteredTables.length;
 
 const handleSearchInput = (event) => {
   setSearchTerm(event.target.value);
   setCurrentPage(1); // Reset to the first page when search changes
 };
 
 const handlePageChange = (pageNumber) => {
   setCurrentPage(pageNumber);
 };
//change the role
  const handleCodeSelectChange = (selectedItem) => {
    console.log("selectedItem",selectedItem)
    const role = selectedItem.value
    setFormData({ ...formData, e_role: role });
  };

  
//change the shop
const handleShopSelectChange = (selectedItem) => {
  console.log("selectedItem",selectedItem)
  const role = selectedItem.value;
  setSelectedShop(role);
  fetchTables(role);
};
const handleSwitchToggle=()=> {
  // Toggle the switch state
  const newStatus = !this.state.imageStatus;
  this.setState({ imageStatus: newStatus });
  // Update localStorage
  localStorage.setItem('image_status', newStatus ? '1' : '0');
  console.log("imagestatus",localStorage.getItem('image_status'));
};
    useEffect(() => {
        fetchTables();
        // fetchShops();
      }, []);


      const fetchTables = async (id) => {
        const token = localStorage.getItem('Token');
        console.log(id)
        const shopId =localStorage.getItem('ShopId');
        try {
           const shop = localStorage.getItem('ShopId')
           const response = await axios.get(`${var_api}supplier-master/get/${shopId}`,{
            headers:{
              Authorization:`${token}`
            }
           });
           console.log("response",response)
          const user =response.data;
          setTables(user);
          
        } catch (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
          setTables([])
        }
      };

      const fetchShops = async () => {
        try {
           const shop = localStorage.getItem('userId')
           const response = await axios.get(`${var_api}/api/shop/data/${shop}`);
           console.log("response",response)
          const user =response.data;
          setShops(user);
          setFormData(prevState => ({
            ...prevState,
            shops: user.map(shop => ({ shop_id: shop.id, shop_name: shop.shop_name, is_active: 0 }))
          }));
        } catch (error) {
          console.log(error);
        }
      };

      const shopCodeOptions = [
        { value: 0, label: 'All' },
        ...shops.map(shop => ({
          value: shop.id,
          label: shop.shop_name
        }))
      ];
      
      

     //search the transaction data
     const filteredSuppliers = tables && tables.filter((order) => {
      const searchLower = searchQuery.toLowerCase();
      return (
        (order.e_name && order.e_name.toString().toLowerCase().includes(searchLower)) ||
        (order.e_email && order.e_email.toString().toLowerCase().includes(searchLower))  ||
        (order.e_phone && order.e_phone.toString().toLowerCase().includes(searchLower))  ||
        (order.e_role && order.e_role.toString().toLowerCase().includes(searchLower)) 
      );
    });

//handle image change
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        console.log("files",file);
        setFormData({ ...formData, profile: file });
      };

//handle text field change
const handleInputChange = (event) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value
  });
};


 // Function to handle checkbox change
 const handleCheckboxChange = (index) => {
  const updatedShops = [...formData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };

  setFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  
   const Submit = (e) => {
    e.preventDefault();
    const shopId=localStorage.getItem('ShopId');
    // Prepare the payload
    const payload = {
      shop_id: shopId, // Replace with the appropriate shop_id value
      supplier_name: formData.supplier_name,
      supplier_code: formData.supplier_code,
      address: formData.address, // Default value for active status
      mobile_no: formData.mobile_no, // Replace with the appropriate value
      gst_no: formData.gst_no, // Replace with the appropriate value

      created_at: new Date().toISOString(), // Current timestamp
      updated_at: new Date().toISOString(), // Current timestamp
    };
  
    const token = localStorage.getItem('Token');
  
    axios
      .post(`${var_api}supplier-master/post`, payload, {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
          Swal.fire("Success", "Supplier created successfully!", "success");
          // handleReset(); // Reset form fields
          // handleClose(); // Close the modal
          fetchTables(); // Refresh the table data
          setFormData({});
          setCreate(false);
      
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error creating data:", error);
        }
        Swal.fire(
          "Error",
          `${error.response?.data?.error || "Unexpected error occurred"}`,
          "error"
        );
      });
  };
  
   


    //reset the values
    const handleToReset = () => {
         // Reset the form fields individually
         setFormData({
          ...formData,
          e_name: " ", 
  e_email: "", 
  e_password:" ",
  e_phone:"",
  e_role:"",
  profile:null
      });
    }

    //Go to home page
    const handleButtonClick = () => {
      history.push('/AdminHome')
    }




      

     //delete method for remove UOM
   const handleDeleteEmployeee = (id) => {
    setShow(true);
    setEmployeeD({id:id})
    }


    //delete the employeee
    const handleDelete = () => {
      const token=localStorage.getItem('Token');
      axios.delete(`${var_api}supplier-master/delete/${DeleteId.id}`,{
        headers:{
          Authorization:`${token}`
        }
      }
      )
        .then((response) => {
          if (response.status === 200) {
            fetchTables(); // Refresh the employee list
            setShow(false);
            Swal.fire("Success", "Supplier removed successfully!", "success");
          } else if (response.status === 404) {
            console.error("Employee not found");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
          Swal.fire("Error", `${error.response.data.message}`, "error");
        });
      };


    //Function for open the update modal
    const handleUpdateEmployee = (data) =>{
      setIsEdit(true);
      console.log("data",data)
      setUpdateFormData({
          id:data.id,
          shop_id: data.shop_id, 
          supplier_name: data.supplier_name, 
          supplier_code: data.supplier_code,
          address: data.address,
          mobile_no: data.mobile_no,
          gst_no: data.gst_no,
      })
    }
    const handleCreateEmployee = () =>{
      setCreate(true);
      setFormData({});
    }

    const handlerefundpopup = () =>{
        setrefundpopup(true);
    }
    //Function for update text field onchange
const handleInputUpdateChange = (e) => {
  const { name, value } = e.target;
  setFormData({ ...formData, [name]: value });
};

const handleInputUpdateChanges = (e) => {
  const { name, value } = e.target;
  setUpdateFormData({ ...updateformData, [name]: value });
};
//Oncahnge function for update role
const handleRoleUpdateChange = (selectedOption) => {
  console.log("hjdahj",selectedOption.value)
  setUpdateFormData({ ...updateformData, e_role: selectedOption.value});
};

//onchange function for file 
const handleImageUpdateChange = (e) => {
  const file = e.target.files[0];
  console.log("file",file)
  setUpdateFormData({ ...updateformData, profile: file });
};


 // Function to handle update checkbox change
 const handleUpdateCheckboxChange = (index) => {
  const updatedShops = [...updateformData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };
  console.log("upd",updatedShops);

  setUpdateFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


//update method for employee
//post method for updating the food
const handleUpdateSubmit = async (e) => {
  e.preventDefault();
  const paymodeData = {
    shop_id: updateformData.shop_id, // Replace with the appropriate shop_id value
    supplier_name: updateformData.supplier_name,
    supplier_code: updateformData.supplier_code,
    address: updateformData.address, // Default value for active status
    mobile_no: updateformData.mobile_no, // Replace with the appropriate value
    gst_no: updateformData.gst_no, // Replace with the appropriate value

  };
  try {
    const token = localStorage.getItem("Token"); // Replace with your token logic
    const response = await axios.put(`${var_api}supplier-master/put/${updateformData.id}`, // Use the selected item's ID
      paymodeData,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (response.status === 200) {
      Swal.fire("success"," Supplier Updated Successfully!","success")

      setIsEdit(false); // Close the modal
      fetchTables(); // Refresh the data
    }
  } catch (error) {
    Swal.fire("Error",  `${error.response?.data?.error || "Unexpected error occurred"}`, "error");
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error updating data:", error);
    }
  }
};





    return(
      <>         <Layout>

     

            <div class="splitrefund">
          
            <div style={{border:"none", padding:"15px", width:"100%", height:"630px",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px", marginTop:"-15px"}}>    
    
    <div>
  
   
     <div class="row">
       <div class="col">
       <h4 className='ushe'>SUPPLIER MASTER</h4>
       </div>
       <div class="col">
       <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Supplier</Button>{' '}
       <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
       </div>
     </div>
      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll'}}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"90%",margin:"auto"}}>
  <thead>
  <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Image</th> */}
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Supplier Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Supplier Code</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Address</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Mobile</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">GST No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
    </tr>
  </thead>
  {loading ? (
        <div className="loader-containeru">
      	  <div className="spinneru"></div>
        </div>
  ) : 
  <tbody class="body-half-screen">
   {/* {filteredSuppliers && filteredSuppliers.length > 0 ? (
   filteredSuppliers && filteredSuppliers.map((data,index) =>( */}

{currentItems && currentItems.length > 0 ? (
   currentItems && currentItems.map((data,index) =>(  
    <tr style={{padding:"4px"}}>
      <th scope="row">{index+1}</th>
      {/* <td style={{textTransform:"capitalize",textAlign:"left"}}><img src={slotimg}  alt='profile' width="35px" height="30px" /></td> */}
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.supplier_name}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.supplier_code}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.address}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.mobile_no}</td>
      <td style={{textTransform:"capitalize",textAlign:"left"}}>{data.gst_no}</td>
      <td style={{textAlign:"left"}}>
   <i class="bi bi-pencil-square" onClick={()=>handleUpdateEmployee(data)}  style={{fontSize:"20px",color:"rgb(9, 97, 9)"}}></i>{' '}
   <i class="bi bi-trash" onClick={()=>handleDeleteEmployeee(data.id)}style={{fontSize:"21px",color:"rgb(175, 2, 2)"}}></i>
   </td>
    </tr>
     ))
    ) : (
     <tr>
       <td colSpan="9" style={{ textAlign: "center", color:"grey", borderColor:"black" }}>
         No Data Available
       </td>
     </tr>
    )}
   {/* ))
   ) : (
    <tr>
      <td colSpan="6" style={{ textAlign: "center", color:"red", fontWeight:"bold", borderColor:"black" }}>
        Slot Not Found
      </td>
    </tr>
   )} */}
 

   </tbody>
}
</table>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Supplier Name 
          <span style={{color:"red",textTransform:"uppercase"}}></span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

      <Modal
        show={isEdit}
        onHide={()=>setIsEdit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Supplier</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={handleUpdateSubmit}>
          <div class="row">
            <div class="col">
              <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Supplier Name</label>
              <input type="text" class="form-control" placeholder="Enter Supplier Name" id="input1" value={updateformData.supplier_name}  name="supplier_name"  onChange={handleInputUpdateChanges}  style={{borderRadius:"12px"}} required/>
            </div>
            <div className="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Supplier Code</label>
            <input type="text" class="form-control" placeholder="Enter Supplier Code" id="input1" value={updateformData.supplier_code}  name="supplier_code"  onChange={handleInputUpdateChanges}  style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Address</label>
            <input type="text" class="form-control" placeholder="Enter Address" id="input1" value={updateformData.address}  name="address"  onChange={handleInputUpdateChanges}  style={{borderRadius:"12px"}} required/>
            </div>
            <div class='col'>
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Mobile</label>
            <input type="number" class="form-control" placeholder="Enter Mobile" id="input1" value={updateformData.mobile_no}  name="mobile_no"  onChange={handleInputUpdateChanges}  style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>GST No</label>
            <input type="text" class="form-control" placeholder="Enter GST No" id="input1" value={updateformData.gst_no}  name="gst_no"  onChange={handleInputUpdateChanges}  style={{borderRadius:"12px"}} required/>
          </div>
       <div class="col">
       </div> 
       </div>
         <br/>
          <button className="btn btn-success" style={{float:"right",margin:"5px",borderRadius:"15px"}}>Update</button>
          </form>
          <button className="btn btn-danger" onClick={()=>setIsEdit(false)} style={{borderRadius:"15px",float:"right",marginTop:"-1px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 

      <Modal
        show={isCreate}
        onHide={()=>setCreate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Create Supplier</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={Submit}>
        <div class="row">
            <div class="col">
              <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Supplier Name</label>
              <input type="text" class="form-control" placeholder="Enter Supplier Name" id="input1" value={formData.supplier_name}  name="supplier_name"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
            <div className="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Supplier Code</label>
            <input type="text" class="form-control" placeholder="Enter Supplier Code" id="input1" value={formData.supplier_code}  name="supplier_code"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Address</label>
            <input type="text" class="form-control" placeholder="Enter Address" id="input1" value={formData.address}  name="address"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
            <div class='col'>
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Mobile</label>
            <input type="number" class="form-control" placeholder="Enter Mobile" id="input1" value={formData.mobile_no}  name="mobile_no"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>GST No</label>
            <input type="text" class="form-control" placeholder="Enter GST No" id="input1" value={formData.gst_no}  name="gst_no"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
          </div>
       <div class="col">
       </div> 
       </div>
        
         <br/>
         <div class="text-center">
          {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
        ) : (
          <button className='btn btn-success' style={{borderRadius:"15px",float:"right",marginTop:"6px"}} disabled={postloading}>Create</button>
        )}
        </div>           </form>
          <button className="btn btn-danger" onClick={()=>setCreate(false)} style={{borderRadius:"15px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 

      <Modal
        show={refundpopup}
        onHide={()=>setrefundpopup(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Apply Refund</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={Submit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Refund Date</label>
               <input type="date" class="form-control" id="floatingInput" placeholder="Select Date" name='Enter date' value={formData.e_name} onChange={handleInputChange}  style={{borderRadius:"15px",height:"50px"}} required/>
               </div>
          </div>
          <br/>
          <div class="row">
          <div className="col">
  <label
    htmlFor="slotSelect"
    style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
  >
    Method
  </label>
  <select
    className="form-control"
    id="slotSelect"
    name="e_slot"
    value={updateformData.e_slot}
    onChange={handleInputChange}
    style={{ borderRadius: "12px" }}
    required
  >
    <option value="">Select</option>
    <option value="slot1">Credit</option>
    <option value="slot2">Debit</option>
    <option value="slot3">Net Banking</option>
    {/* Add more options as needed */}
  </select>
</div>
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Amount{" "}</label>
            <input type="number" class="form-control" id="formFile" placeholder='Enter Amount' onChange={handleImageChange} name='profile'  style={{borderRadius:"15px",height:"50px"}} />
            </div>
          </div>
          <div class="row">
          <div className="col">
      <label htmlFor="description" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
        Refund Notes
      </label>
      <textarea
        id="description"
        className="form-control"
        value={remarks}
        onChange={setRemarks}
        placeholder="Enter a description..."
        rows="4"
        style={{ borderRadius: "15px", height: "100px", resize: "vertical" }} // Matches other input styles
        required
      />
    </div>
       </div>
         <br/>
         <div class="text-center">
          {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
        ) : (
          <button className='btn btn-success' style={{borderRadius:"15px",float:"right",marginTop:"6px"}} disabled={postloading}>Apply</button>
        )}
        </div>           </form>
          <button className="btn btn-danger" onClick={()=>setrefundpopup(false)} style={{borderRadius:"15px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 


            {/* </div> */}
       </Layout></>

        
    )
}

export default AdminSupplierMaster;